(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pc-lifestyle-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pc-lifestyle-hero')) {
    class PcLifestyleHero extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        this.abort = new AbortController();
        this.config = JSON.parse(this.querySelector('[data-hero-config]').textContent);
        this.slides = [...this.querySelectorAll('[data-hero-slide]')];
        this.video = this.querySelector('[data-hero-video]');
        this.poster = this.querySelector('.pc-hero__poster');
        this.stage = this.querySelector('[data-hero-stage]');
        this.playButton = this.querySelector('[data-hero-play]');
        this.soundButton = this.querySelector('[data-hero-sound]');
        this.position = this.querySelector('[data-hero-position]');
        this.status = this.querySelector('[data-hero-status]');
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.index = 0;
        this.inView = false;
        this.muted = true;
        this.hoverPaused = false;
        this.focusPaused = false;
        this.userPaused = this.motion.matches || Boolean(navigator.connection?.saveData) || Boolean(window.Shopify?.designMode);
        const on = (target, event, handler) => target.addEventListener(event, handler, {signal:this.abort.signal});
        on(this.querySelector('[data-hero-previous]'), 'click', () => this.select(this.index - 1, true));
        on(this.querySelector('[data-hero-next]'), 'click', () => this.select(this.index + 1, true));
        on(this.playButton, 'click', () => {
          this.userPaused = !this.userPaused;
          this.hoverPaused = false;
          this.focusPaused = false;
          if (this.userPaused) this.pauseFor('button');
          else {
            if (this.video.ended) this.video.currentTime = 0;
            this.playIfAllowed();
          }
          this.updateControls();
        });
        on(this.soundButton, 'click', () => {
          this.muted = !this.muted;
          this.video.muted = this.muted;
          this.updateControls();
        });
        on(this.video, 'volumechange', () => {this.muted = this.video.muted;this.updateControls();});
        on(this.video, 'playing', () => {
          this.stage.classList.add('is-playing');
          this.pauseReason = null;
          this.updateControls();
        });
        on(this.video, 'play', () => {
          if (!this.inView || document.hidden) this.pauseFor('visibility');
          else if (this.userPaused) {
            this.userPaused = false;
            this.hoverPaused = false;
            this.focusPaused = false;
            this.updateControls();
          }
        });
        on(this.video, 'pause', () => {
          if (this.pauseReason) this.pauseReason = null;
          else if (!this.video.ended) this.userPaused = true;
          this.updateControls();
        });
        on(this.video, 'ended', () => {
          if (!this.userPaused && !this.hoverPaused && !this.focusPaused && this.inView && !document.hidden && !this.motion.matches && !navigator.connection?.saveData && this.config.slides.length > 1) this.select(this.index + 1, false);
          else {this.userPaused = true;this.updateControls();}
        });
        on(this.video, 'error', () => {
          this.stage.classList.remove('is-playing');
          this.userPaused = true;
          this.status.textContent = this.config.strings.unavailable;
          this.updateControls();
        });
        on(this, 'focusin', event => {
          if (this.contains(event.relatedTarget)) return;
          this.focusPaused = true;
          this.pauseFor('focus');
        });
        on(this, 'focusout', event => {
          if (this.contains(event.relatedTarget)) return;
          this.focusPaused = false;
          this.playIfAllowed();
        });
        on(document, 'visibilitychange', () => {if (document.hidden) this.pauseFor('visibility');else this.playIfAllowed();});
        on(this.motion, 'change', () => {if (this.motion.matches) {this.userPaused = true;this.pauseFor('motion');this.updateControls();}});
        on(document, 'shopify:block:select', event => {
          const found = this.config.slides.findIndex(slide => slide.blockId === event.detail.blockId);
          if (found >= 0) this.select(found, true);
        });
        this.observer = new IntersectionObserver(entries => {
          this.inView = entries[0].isIntersecting && entries[0].intersectionRatio >= 0.25;
          if (this.inView) this.playIfAllowed();
          else this.pauseFor('offscreen');
        }, {threshold:[0,0.25]});
        this.observer.observe(this.stage);
        this.querySelectorAll('.pc-hero__controls button').forEach(button => {button.disabled = false;});
        this.select(0, false);
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.observer?.disconnect();
        this.video?.pause();
        this.abort = null;
      }
      pauseFor(reason) {
        if (this.video.paused) return;
        this.pauseReason = reason;
        this.video.pause();
      }
      playIfAllowed() {
        if (this.userPaused || this.hoverPaused || this.focusPaused || !this.inView || document.hidden) return;
        this.video.play().catch(error => {
          if (!this.isConnected) return;
          if (error.name === 'AbortError') return;
          this.userPaused = true;
          this.updateControls();
        });
      }
      select(index, userAction) {
        if (userAction) this.userPaused = true;
        this.pauseFor('slide');
        this.index = (index + this.config.slides.length) % this.config.slides.length;
        const item = this.config.slides[this.index];
        this.slides.forEach((panel, position) => {
          const active = position === this.index;
          panel.classList.toggle('is-active', active);
          panel.setAttribute('aria-hidden', String(!active));
          panel.inert = !active;
        });
        this.stage.classList.remove('is-playing');
        this.poster.src = item.poster;
        this.poster.srcset = item.posterSrcset;
        this.poster.alt = item.alt;
        this.video.poster = item.poster;
        this.video.setAttribute('aria-label', item.alt);
        this.video.muted = this.muted;
        this.video.preload = 'metadata';
        this.video.src = item.src;
        this.video.load();
        this.position.textContent = `${this.index + 1} / ${this.config.slides.length}`;
        this.status.textContent = userAction ? item.title : '';
        this.updateControls();
        this.playIfAllowed();
      }
      updateControls() {
        this.playButton.textContent = this.userPaused ? this.config.strings.play : this.config.strings.pause;
        this.playButton.setAttribute('aria-pressed', String(this.userPaused));
        this.soundButton.textContent = this.muted ? this.config.strings.soundOn : this.config.strings.mute;
        this.soundButton.setAttribute('aria-pressed', String(!this.muted));
      }
    }
    customElements.define('pc-lifestyle-hero', PcLifestyleHero);
  }

  } catch(e) { console.error(e); }
})();
})();
